/**
 * Created by lari on 08/06/2017.
 */
(function () {
  'use strict';
  angular.module('vcfinance.cart')
    .component('cartform', {
      restrict: 'E',
      bindings: {
        cart: '<',
        parentsave: '&',
        oncancel: '&'
      },
      templateUrl: 'vcfinance/cart/cartform-component.tpl.html',
      controllerAs: 'vm',
      controller: ['$log',
        function ($log) {
          let vm = this;
          vm.save = save;
          vm.cancel = cancel;
          // vm.zipsave = zipsave;
          
          vm.$onInit = function () {
            vm.lastcart = angular.copy(vm.cart);
          };
          
          function save() {
            if (!angular.equals(vm.cart, vm.lastcart)) {
              vm.lastcart = angular.copy(vm.cart);
              vm.parentsave({cart: vm.cart});
            }
          }
          
          function cancel() {
            vm.cart = angular.copy(vm.lastcart);
            vm.oncancel();
          }
          
/*          function zipsave (zip, city) {
            $log.debug('debug: cartform zipsave called: ', zip, city);
            // vm.cart.postcode = zip;
            // vm.cart.city = city;
          }*/
          
          
          
        }] // controller
    }); // component

// klammerfriedhof
}());